module.exports = __webpack_public_path__ + "static/anti-racist-teaching-9cbe032f7c093cd4499830af455c365a.jpg";